const classNames = {
  loggedOutButton: 'main-banner-logged-out-button',
  imageLogoutContainer: 'main-banner-logout-image-container',
  imageLogout: 'main-banner-logout-image',
  currencyInfoTitle: 'main-banner-logout-currency-info',
};

export default classNames;
